import { Suspense } from "react";
import SchedulePage from "@/app/booking/schedule/schedule-page";
import SchedulePageSkeleton from "@/components/schedule-page-skeleton";

export default function BookingSchedulePage() {
  return (
    <Suspense fallback={<SchedulePageSkeleton />}>
      <SchedulePage />
    </Suspense>
  )
}
